import { useMemo, useState } from "react";
import { useFuseSearch } from "@elixir/utils";
import {
  Appointment,
  SUBJECT_KEYS,
  TAptField,
  TAptFieldOption,
} from "@elixir/types";
import usePushAptFieldToApt from "../../../../apis/tryst/use-push-apt-field-to-apt";
import SelectionDropdown from "./selection-dropdown";

const OptionsSelectDropdown = ({
  apt,
  fieldItem,
  isDisabled = false,
}: {
  apt: Appointment;
  fieldItem: TAptField;
  isDisabled?: boolean;
}) => {
  const { options, fieldMeta, title } = fieldItem;
  const { subType } = fieldMeta;

  const { mutate: pushAptFieldToApt } = usePushAptFieldToApt();
  const [searchQuery, setSearchQuery] = useState<string>("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const filteredOptions =
    useFuseSearch(searchQuery, options || [], ["value"]) || [];

  const searchOptions = useMemo(() => {
    if (searchQuery && searchQuery.length > 0) {
      return filteredOptions;
    }
    return options || [];
  }, [filteredOptions, options, searchQuery]);

  const handleOptionSelect = (optionsToPush: TAptFieldOption[]) => {
    pushAptFieldToApt({
      appointment: apt,
      fieldId: fieldItem.field_id,
      fieldValues: optionsToPush.map(({ id, value, description }) => id),
    });
  };

  const aclSubjectKey =
    `APT_FIELD#${fieldItem.field_id.toUpperCase()}` as SUBJECT_KEYS;

  return (
    <SelectionDropdown
      searchQuery={searchQuery}
      onSearch={setSearchQuery}
      dropdownOptions={options || []}
      filteredOptions={searchOptions}
      type={subType}
      title={title}
      onOptionSelect={handleOptionSelect}
      aclSubjectKey={aclSubjectKey}
      isDisabled={isDisabled}
    />
  );
};

export default OptionsSelectDropdown;
